import { css } from 'styled-components';
export const defaultColors = {
    paleSkyBlue: "#CFE2FC",
    neutral000: "#FFFFFF",
    neutral100: "#F1F5FF",
    neutral200: "#E2E9FC",
    neutral300: "#C0C9E5",
    neutral400: "#96A1C1",
    neutral500: "#687499",
    neutral600: "#485274",
    neutral700: "#313B5B",
    neutral800: "#1B244B",
    neutral900: "#081032",
    brand25: "#F7F9FF",
    brand50: "#F1F4FF",
    brand75: "#E3E9FF",
    brand100: "#C9D5FF",
    brand200: "#96ACFF",
    brand300: "#6684FF",
    brand400: "#3F67FC",
    brand500: "#2A4FDA",
    brand600: "#193AB8",
    brand700: "#0B2996",
    brand800: "#021A74",
    brand900: "#001152",
    black: "#000000",
    atlanticBlue700: "#0B2574",
    atlanticBlue900: "#00134B",
    blue2: "#1E3E9D",
    brightBlue: "#0041D9",
    lavenderBlue: "#C1CEFF",
    aliceBlue: "#EAF1FF",
    umbuGreen300: "#E7F79E",
    umbuGreen400: "#D1E575",
    bannerGrey: "#ECF0FF",
    grey: "#D9D9D9",
    deepPurple: "#50499D",
    slateBlue: "#6C789D",
    greenMenta: "#CAF8DB",
    darkGrey: "#333333",
    darkSlateBlue: "#485274",
    blueLight: "#96ACFF",
    skyGaze: "#96ACFF",
    softLinen: "#FDFFF6",
    deepPurpleInverse: "#8F85F4",
    azulBordaDefault: "#96ACFF",
    azulBordaFocus: "#6684FF",
    azulNuvem: "#96ACFF",
    darkPanelBackground: "#081032",
    paleLightBlue: "#E2E9FC",
    umbuGreenFigma: "#D1E675",
    bannerGreyTransparent: "rgba(236, 240, 255, 0)",
    lightPeriwinkleOpacity30: "rgba(201, 213, 255, 0.3)",
    neutralDarkText: "#343A40",
    textDisabledLight: "#ADB5BD",
    neutralBorderLight: "#DEE2E6",
    backgroundLight: "#F8F9FA",
    backgroundHoverLight: "#E9ECEF",
    textDefaultInactiveDark: "#A0A8C0",
    textDisabledDark: "#6C757D",
    borderDark: "#495057",
    borderDefaultInactiveDark: "#505870",
    backgroundDark: "#212529",
    cloudGray: "#DDE5E8",
    errorRedIcon: "#B20000",
    errorRed: "#F53D3D",
    successGreen: "#008537",
    successGreenLight: "#35B068",
    yellowAlert: "#AB6005",
    cardSecondary: "#F7F9FF",
    overlay: "rgba(0, 0, 0, 0.5)",
    backgroundSubtler: "rgb(241, 244, 255)",
    contentSubtler: "#687499",
    purple500: "#BE64E3",
    lightBlue500: "#65B7FB",
    orange300: "#FFB2B2",
    purpleHover: "#FBF1FF",
    lightBlueHover: "#F0F8FF",
    orangeHover: "#FCEEED",
    orangeBorder: "#FFE5E5",
    editorBackgroundLight: "#F5F5F5",
    editorBorderLight: "#CCCCCC",
    editorTextMedium: "#666666",
    editorTextLight: "#888888",
    overlayLight: "rgba(0, 0, 0, 0.1)",
};
// Simplificação para Design System: exporta diretamente o objeto de cores
// A aplicação consumidora pode sobrescrever via ThemeProvider se necessário
export const colors = defaultColors;
export const sizes = {
    mobile: 360,
    tablet: 768,
    desktop: 1280,
    desktopLarge: 1600,
};
export const margins = {
    mobile: 16,
    tablet: 48,
    desktop: 48,
};
export const devices = {
    mobile: `(max-width: ${sizes.tablet - 1}px)`,
    tablets: `(max-width: ${sizes.desktop - 1}px)`,
    desktop: `(min-width: ${sizes.desktop}px)`,
    onlyTablets: `(min-width: ${sizes.tablet}px) and (max-width: ${sizes.desktop - 1}px)`,
    desktopLarge: `(min-width: ${sizes.desktopLarge}px)`,
};
export const applyBigLinkStyle = () => css `
	color: ${colors.brand500};
	font-family: "Figtree", sans-serif;
	font-size: 18px;
	font-weight: 700;
	line-height: 24px;

	&:hover {
		color: ${colors.brightBlue};
	}

	&:focus {
		border: 3px solid ${colors.brand300};
		border-radius: 4px;
		padding: 0 4px;
	}

	&:visited {
		color: ${colors.deepPurple};
	}

	&:disabled {
		color: ${colors.brand75};
	}
`;
export const widthDesktopMarginAutoStyle = css `
	max-width: ${sizes.desktop}px;
	margin-left: auto;
	margin-right: auto;
`;
export const maxLinesStyle = (n) => css `
	-webkit-line-clamp: ${n};
	display: -webkit-box;
	-webkit-box-orient: vertical;
	overflow: hidden;
`;
//# sourceMappingURL=variables.styled.js.map